import { set, get, del } from 'idb-keyval';

const STORAGE_PREFIX = 'barcode-scanner/';
const SETTINGS_STORAGE_KEY = 'settings';
const HISTORY_STORAGE_KEY = 'history';

/**
 * Gets an item from the storage.
 *
 * @param {string} key - The key to get the item from.
 * @returns {Promise<[ error: any, value: any ]>} The item and an error if occurred.
 */
const getItem = async key => {
  try {
    return [null, await get(key)];
  } catch (error) {
    return [error, void 0];
  }
};

/**
 * Sets an item in the storage.
 *
 * @param {string} key - The key to set the item to.
 * @param {any} data - The data to set.
 * @returns {Promise<[ error: any ]>} An error if occurred.
 */
const setItem = async (key, data) => {
  try {
    await set(key, data);
    return [null];
  } catch (error) {
    return [error];
  }
};

/**
 * Deletes an item from the storage.
 *
 * @param {string} key - The key to delete the item from.
 * @returns {Promise<[ error: any ]>} An error if occurred.
 */
const deleteItem = async key => {
  try {
    await del(key);
    return [null];
  } catch (error) {
    return [error];
  }
};

/**
 * Gets the settings from the storage.
 *
 * @returns {Promise<[ error: any, value: any ]>} The settings and an error if occurred.
 */
export const getSettings = async () => {
  return getItem(STORAGE_PREFIX + SETTINGS_STORAGE_KEY);
};

/**
 * Sets the settings in the storage.
 *
 * @param {any} data - The settings to set.
 * @returns {Promise<[ error: any ]>} An error if occurred.
 */
export const setSettings = async data => {
  return setItem(STORAGE_PREFIX + SETTINGS_STORAGE_KEY, data);
};

/**
 * Gets the history from the storage.
 *
 * @returns {Promise<[ error: any, value: any ]>} The history and an error if occurred.
 */
export const getHistory = async () => {
  return getItem(STORAGE_PREFIX + HISTORY_STORAGE_KEY);
};

/**
 * Sets the history in the storage.
 *
 * @param {any} data - The history to set.
 * @returns {Promise<[ error: any ]>} An error if occurred.
 */
export const setHistory = async data => {
  return setItem(STORAGE_PREFIX + HISTORY_STORAGE_KEY, data);
};

/**
 * Clears the history and settings from storage.
 * @returns {Promise<void>}
 */
export const clearSensitiveData = async () => {
  await deleteItem(STORAGE_PREFIX + HISTORY_STORAGE_KEY);
  await deleteItem(STORAGE_PREFIX + SETTINGS_STORAGE_KEY);
  // We should also clear any other session-related data here
  localStorage.removeItem('dossierNumber');
  document.getElementById('scanned-items-container').innerHTML = '';
  document.querySelector('#global-total span').textContent = '0.00';
  document.getElementById('dossier-display').textContent = '';
  document.getElementById('dossier-input-container').hidden = false;
  document.getElementById('dossier-display-container').hidden = true;
};
